import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import auth from 'components/Page/auth/reducer'
import loader from 'redux/loader/reducer'
import filter from 'components/Page/Home/Filter/reducer'

export default history =>
  combineReducers({
    filter,
    loader,
    auth,
    router: connectRouter(history),
  })
